import React from 'react';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { api } from '../AppConfig';
import MeContext from './MeContext';
import * as Setting from '../utils/AuthUtils';

function MeProvider({ children }) {
  const meQuery = useQuery({ 
    queryKey: ['userInfo'], 
    queryFn: () => 
      fetch(api.me().href, {
        headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Setting.getToken(),
        // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
      .then((res) =>
        res.json(), 
      )
  })
  return <MeContext.Provider value={meQuery.data}>{children}</MeContext.Provider>;
}

export default MeProvider;